
















































import { Component, Vue,Prop ,Watch} from "vue-property-decorator";
import _com from "@/assets/js/common";
import jsonp from "@/assets/js/http";
import fetch from "@/assets/js/fetch";
import _intercept from "@/assets/js/intercept";
@Component({
    computed:{
        
    },
    components: {}
})
export default class luckCartModal extends Vue {
    @Prop() diff: any = 0
	@Watch("diff") // 更新接收的值  ，不然只会显示第一次接收到的值
	watchDiff(newVal: number) {
		this.difference = newVal;
	}   
    difference: number = 0; 
    browser = _com.browser();
    channel:any = '300000'
	get roomData() {//房间数据
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}    
    isClick = true;
    get cardAllData(){// 福卡数据
        let cardAllData = this.$store.getters["refresh/getLuckCardAllData"];
        console.log(cardAllData);
        console.log('福卡所有数据');
        return cardAllData
    } 
    get cardData(){// 最后发放福卡数据
        let luckCardAct = this.$store.getters["refresh/getLuckCardAct"];
        console.log(luckCardAct);
        console.log('最后发放福卡数据');
        if (luckCardAct && this.cardAllData.actNum == 1) {
            if (!_com.getMallCookie()) {
                luckCardAct.claimStaus = 999;
            } else {
                this.getCardState(luckCardAct);
            }            
            this.countdown(luckCardAct.endTime)
        }
        return luckCardAct
    } 
    luckCardtimer:any = null;
    claimStaus:any = -1; //13：当前活动已集齐 14：已兑奖； 1：当前轮次已领取  0：当前轮次未领取   999:未登录
    counttime:any = 0;
    close() { 
        clearInterval(this.luckCardtimer);
        this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showPop',value:false});
    }
    openMore(){ 
        if (!_intercept()) {
            return;
        }        
        this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showListPop',value:true});
        this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showPop',value:false});
    }
    countdown(endTime:any){ 
        clearInterval(this.luckCardtimer);
        let now = new Date().getTime() + this.difference;
        let time = new Date(endTime).getTime();
        if (Math.round((time - now)/1000) <= 0) {
            this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showPop',value:false});
            return;
        } else { 
            this.counttime = Math.round((time - now)/1000);
        }
        this.luckCardtimer = setInterval(() => {
            if (this.counttime <= 0) {
                clearInterval(this.luckCardtimer);
                this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showPop',value:false});
                return;
            }             
            this.counttime--
        }, 1000);
    }
    getCardState = (card:any) => { 
		const callback = 'getCardState'
		jsonp(`https://m${process.env.VUE_APP_URI_DOMAIN}/mobileact/liveFuCard/queryUserFuCardState`, {
			jsoncallback: callback,
            cardActivityNo:card.cardActivityNo,
            roundId:card.roundId
		}).then((data: any) => {
            card.claimStaus = data;
		})
    }
    claimCard(card:any){ //领卡
        if (!_intercept() || !this.isClick) {
            return;
        }
		const callback = 'claimCard'
        let url = `https://service${process.env.VUE_APP_URI_DOMAIN}/act-assist/ulelivebarrage/api/v1/luckyCardActivity/user/receiveCard`;        
        let params = {
            roomName: this.roomData.roomNumber,
            sceneId: this.roomData.scene_id,
            cardNo:card.cardNo,
            roundId:card.roundId,
            batchId:card.id,
            channel:this.channel,     
        }
        console.log(this.roomData);
        console.log(card);
        this.isClick = false;
        fetch({
            url: url,
            params,
            method: "post"
        }).then((res: any) => {
            this.$toast('领取成功')
            setTimeout(()=>{
                this.getCardState(card)
                this.isClick = true;
            },1500)
        }).catch((err: any) => {
            this.isClick = true;
            this.$toast(err.msg || '领取失败请稍后重试')
        });              
    }
    combCard(card:any){ //合成卡
        if (!_intercept() || !this.isClick) {
            return;
        }
        let url = `https://m${process.env.VUE_APP_URI_DOMAIN}/mobileact/liveFuCard/cardCombineDraw`;        
		const callback = 'combCard'
        this.isClick = false;
		jsonp(url, {
			jsoncallback: callback,
            cardActivityNo:card.cardActivityNo,
            channel:this.channel,   
		}).then((data: any) => {
            this.$toast(data.msg || '兑换成功')
            setTimeout(()=>{
                this.isClick = true;
                this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showPop',value:false});
            },1500)
		}) .catch((err: any) => {
            this.isClick = true;
            this.$toast(err.message || '合卡失败请稍后重试')
        });        
    }
	mounted() {
		if (this.browser.ylxdsq) {
			this.channel = '610003'	
		} else if (this.browser.usqxcx) {
			this.channel = '610002'	
		} else if (this.browser.ylxd) {
			this.channel = '600000'
		} else if (this.browser.yzgxd) {
			this.channel = '400006'
		} else if (this.browser.ule) {
			this.channel = '200000'
		}    		    
	}
	destroyed() {
		clearInterval(this.luckCardtimer);
		this.luckCardtimer = null
	}
}

